import * as React from 'react';
import Top from "../Top";
import Bottom from "../Bottom";
import { useNavigate } from 'react-router-dom';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import AlarmIcon from '@mui/icons-material/Alarm';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { selfQuestionnaires } from "../../utils/selfQuestionnaires";

const SelfCheckList = () => {
  const navigate = useNavigate();
  const questionTime = 20;


  return (
    <Container sx={{ bgcolor: '#F6F6F6', minHeight: '100vh', pt: 7, pb: 12, pl: 0, pr: 0, minWidth: 320 }}>
      <Top title='자가진단 검사' />


      <Box sx={{ bgcolor: '#FFFBF8', p: 2 }}>
        <Typography sx={{ fontSize: 14, color: '#333' }}>
          간단한 자가진단 테스트입니다. <br />
          질병을 진단하는 것이 아닌 참조로
          사용할 수 있는 테스트로 증상이 심각한 경우 반드시 병원을 방문하여 전문의와 상의하세요.
        </Typography>
      </Box>

      <Grid container spacing={2} columns={16} sx={{ mt: 2, pl: 2, pr: 2 }}>
        <Grid item xs={16}>
          {selfQuestionnaires && selfQuestionnaires.map((item, index) => (
            <Stack key={item.no ?? index} direction='row' justifyContent={'center'} alignItems={'center'} onClick={() => navigate('../check/SelfStart', { state: { selfQuestionNo: item.no } })} sx={Card_Style}>
              <Stack direction={'column'}>
                <Typography sx={{ fontSize: 16, color: '#555', fontWeight: 700, mb:1 }}>{item.title}</Typography>

                <Stack direction={'row'} alignItems={'center'}>
                  <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
                    <TaskAltIcon sx={{ fontSize: 16, pr:.5, color:'#777' }} />
                    <Typography sx={{ fontSize: 14, color:'#777'}}>문항</Typography>
                    <Typography sx={{ fontSize: 14,pl:.5, color: '#777', fontWeight: 500  }}>{item.questions.length}</Typography>
                    <Typography sx={{ fontSize: 14, color:'#777'}}>개</Typography>
                  </Stack>
                
                  <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ml:2}}>
                    <AlarmIcon sx={{ fontSize: 16, pr:.5, color:'#777' }} />
                    <Typography sx={{ fontSize: 14, color:'#777'}}>시간</Typography>
                    <Typography sx={{ fontSize: 14,pl:.5, color: '#777', fontWeight: 500 }}>{Math.floor(item.questions.length*questionTime / 60)}</Typography>
                    <Typography sx={{ fontSize: 14, color:'#777'}}>분</Typography>
                  </Stack>
                </Stack>

              </Stack>
              <KeyboardArrowRightIcon sx={{ ml: 'auto', color: '#999', }} />
            </Stack>
          ))}
        </Grid>

        {/*<Grid item xs={16}>
          <Box sx={Card_Style}>
            <Typography  sx={{ fontSize: 14, color: '#555', fontWeight:700 }}>
            우울증
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={8}>
          <Box sx={Card_Style}>
            <Typography  sx={{ fontSize: 14, color: '#555', fontWeight:700 }}>
            과민성 방광
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={8}>
          <Box sx={Card_Style}>
            <Typography  sx={{ fontSize: 14, color: '#555', fontWeight:700 }}>
            탈모 
            </Typography>
          </Box>
        </Grid>*/}

      </Grid>

      <Bottom />
    </Container >
  );
}

const Card_Style = {
  p: 2,
  mb: 2,
  borderRadius: '10px',
  background: '#fff',
  boxShadow: '0 0 6px  rgba(0,0,0,0.2)',
  maxWidth: '100%',
};

export default SelfCheckList;